import {ApplyAction} from "~/types/applyAction";
import {type FetchResponse} from "ofetch";
import type {AsyncDataExecuteOptions} from "#app/composables/asyncData";
import type {BaseEntity} from "~/types/entity";
import {useToast} from "#imports";
import type {TSide} from "~/types/constellation/constellation-types";


export function showErrorToast(message: string | undefined) {
    const toast = useToast()
    toast.add({
        id: 'error_toast',
        title: 'Ошибка',
        description: message ?? "Что пошло не так",
        icon: 'i-heroicons:light-bulb-solid',
        timeout: 3000,
        color: 'red',
        ui: {
            title: 'text-red-600'
        }
    })
}

export function showOKToast () {
    const toast = useToast()
    toast.add({
        title: 'Изменения сохранены!',
        description: 'Все данные были успешно сохранены в базе данных',
        icon: 'i-heroicons-cloud-arrow-down-20-solid',
        timeout:2000,
        ui: {
            background: 'bg-green-200'
        }
    })
}

export function nameText(data: BaseEntity) {
    return data.active ? data.name : `${data.name} (не активен)`
}

export function getTextDataRowClass (data: BaseEntity) {
    return ((data.active) ? 'active-row-item' : 'no-active-row-item') + ' text-wrap'
}

export function getDataRowClass() {
    return 'active-row-item text-wrap'
}

export function getControlItemClass(current: boolean) {
    return current ? 'control-item-current' : 'control-item'
}

export async function doActive (
        active: string,
        range: any[],
        refresh:Ref<(opts?: AsyncDataExecuteOptions | undefined) => Promise<void>>,
        target: string,
        all: boolean=false,
        order: number|undefined = undefined) {
    const res = await new ApplyAction().apply({
        all,
        range,
        action: active,
        target,
        order,
        filter: '',
        param: []
    })

    if (res.status)
        await refresh?.value?.()
    else
        showErrorToast(res.error)
}

export function setPagionationData(
    response: FetchResponse<any>,
    rows: Ref<any>,
    count: Ref<number>,
    total: Ref<number>) {
        const {data} = response._data
        rows.value = data?.data ?? []
        count.value = data?.per_page ?? 0
        total.value = data?.total ?? 0
}

export function booleanToTableText(value: boolean): string {
    return value ? 'Да' : 'Нет'
}

export const tableDataUI = () => {
    return {
        th: {
            color: 'z-10 page-app-background',
            base: 'sticky top-0',
            padding: 'px-1 py-1',
        },
        td: {
            padding: 'px-1 py-1',
            size: 'text-xs',
        },
        tr: {
            base: 'table-data-color',
        }
    }
}

export const tableUI = () => {
    return {
        thead: 'item-table-header',
        th: {
            color: 'item-table-header-cell',
            base: 'sticky top-0',
            padding: 'px-1 py-1',
        },
        td: {
            base: 'item-table-data-cell',
            padding: 'px-1 py-1',
            size: 'text-xs'
        },
        tr: {
            base: 'item-table-data-color',
        }
    }
}

export const tableDataActiveUI = () => {
    const res: any = tableDataUI()
    res.td.color = 'text-black dark:text-white'
    return res
}

export interface IVueComponent {
    instance: any
    element: HTMLElement
}

export function getVueComponentUnderCursor(
    x: number,
    y: number,
    name?: string
): IVueComponent | null {
    const el = document.elementFromPoint(x, y) as any
    if (!el) return null

    let cur: any = el

    while (cur) {
        const inst = cur.__vueInstance
        if (inst) {
            const compName = inst.type?.name || inst.type?.__name
            if (!name || compName === name) {
                return { instance: inst, element: cur as HTMLElement }
            }
        }
        cur = cur.parentElement
    }

    return null
}

export function getNearestSide (
    x: number,
    y: number,
    rect: DOMRect
): TSide {
    const distTop = Math.abs(y - rect.top)
    const distBottom = Math.abs(y - rect.bottom)
    const distLeft = Math.abs(x - rect.left)
    const distRight = Math.abs(x - rect.right)

    const min = Math.min(distTop, distBottom, distLeft, distRight)

    if (min === distTop) return 'top'
    if (min === distBottom) return 'bottom'
    if (min === distLeft) return 'left'
    return 'right'
}

export function getVueComponentsUnderCursor(
    x: number,
    y: number,
    name?: string
): IVueComponent[] {
    const elements = document.elementsFromPoint(x, y) as any[]
    const result: IVueComponent[] = []

    for (const el of elements) {
        let cur: any = el

        while (cur) {
            const inst = cur.__vueInstance
            if (inst) {
                const compName = inst.type?.name || inst.type?.__name
                if (!name || compName === name) {
                    result.push({ instance: inst, element: cur as HTMLElement })
                    break // нашли Vue-инстанс для этого DOM-элемента – идём к следующему
                }
            }
            cur = cur.parentElement
        }
    }

    return result
}
